import styled from "styled-components";
import {useAppDispatch, useAppSelector} from "../../../../hooks";
import React, {useState} from "react";
import {OverlayContainer} from "../../../misc/ImageViewer";
import {schemas} from "../../../../config";
import AddTableRecord from "./AddTableRecord";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faAnglesLeft, faMeteor} from "@fortawesome/free-solid-svg-icons";


type PropsI = { pkValue: string | number | undefined, tableKey: string };
export default function RawAddTableRecordModal({pkValue, tableKey}: PropsI) {


    const [isOpen, setIsOpen] = useState(false);
    const project = useAppSelector(state => state.project.name);
    const schema = schemas[project];

    return <>
        <Button className={'btn-cmn'} onClick={() => setIsOpen(true)}>
            {pkValue !== undefined ? 'Створити новий на основі' : <IconBtn>
                <div className={'ic'}>
                    <FontAwesomeIcon title={'sort'} icon={faMeteor}
                                     width={'.8em'}
                                     className={'fa-secondary-color-text'}/>
                </div>
                <span>➕</span>

            </IconBtn>}
        </Button>
        {isOpen && <OverlayContainer $isVisible onClick={() => setIsOpen(false)}>
            <Container onClick={(e: { stopPropagation: () => void; }) => e.stopPropagation()}>
                <AddTableRecord fields={schema.tables[tableKey].fields} backendUrl={schema.backend} project={project}
                                closeEdit={() => setIsOpen(false)}
                                tableKey={tableKey} pkValue={pkValue}/>
            </Container>
        </OverlayContainer>}
    </>
}

const Button = styled.button`
    width: 100%;
    padding: .2rem;
    overflow: hidden;
    
`
const IconBtn =  styled.div`
    position: relative;

    & .ic {
        position: absolute;
        
        bottom: -40%;
        right: 0;
        z-index: 0;
    }
`

const Container = styled.div`
    //height: 100%;
    max-height: calc(98vh - var(--header-height));
    height: 100%;
    background-color: var(--table-row-odd-bg-color);
    padding: .5rem;
    border-radius: .5rem;
    max-width: 1200px;
    width: 100%;
    min-width: 340px;
    min-height: 50vh;
    overflow-y: auto;
    display: flex;
    flex-flow: column;
    gap: .5rem;


    .controls {
        display: flex;
        justify-content: end;
        gap: .5rem;
    }

    .check {
        display: flex;
        margin-top: auto;
        gap: .5rem;
    }

    & .entries {
        display: flex;
        flex-flow: column;
        gap: .5rem;
        justify-content: center;
    }

    .loader {
        width: 100%;
        height: 500px;
    }
`
